import { render, staticRenderFns } from "./SchoolEnrollmentsForm.vue?vue&type=template&id=943534ea&"
import script from "./SchoolEnrollmentsForm.vue?vue&type=script&lang=js&"
export * from "./SchoolEnrollmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SchoolEnrollmentsForm.vue?vue&type=custom&index=0&blockType=styles&scoped=true&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports